import React from 'react';
import Loadable from 'react-loadable';
import { Loading } from '@stormideas/react-sdk';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading visible />,
});

export const Report = Loadable({
  loader: () => import('./containers/ReportPage'),
  loading: () => <Loading visible />,
});
